import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncUnitSelect } from '../../Shared/AsyncUnitSelect'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>ارجاع به واحد</legend>

        <div className="row">
          <div className="form-inline">

            <div className="col-md-12 col-sm-12">
              <label>انتخاب واحد</label>
              <AsyncUnitSelect
                unitType={6}
                defaultValue={values.unitId}
                name="unitId"
                onChange={(val, unitType) => {
                  // console.log(val);

                  setFieldValue('unitType', unitType)
                  setFieldValue('unitId', val)
                }}

                className={getIn(touched, "unitId") ? getIn(errors, "unitId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="unitId" />
            </div>

            <div className="col-md-12 col-sm-12">
              <label>توضیحات</label>
              <Field name="description" rows="2"
                render={({ field }) =>
                  <textarea {...field}
                    value={values.description || ''}
                    className="textarea rtl"
                  />}
              />
            </div>
          </div>
        </div>



      </fieldset>

    </div>

  </div>
);